import { createCombobox } from "./combobox";

const bodyScrollLock = require('body-scroll-lock');
// const disableBodyScroll = bodyScrollLock.disableBodyScroll;
// const enableBodyScroll = bodyScrollLock.enableBodyScroll;


"use strict";

if (!("ui" in window)) {
  window.ui = {};
}



// ********************
// DOM Variables
var uiRoot = document.body;
var uiMasthead = document.querySelector(".ui-masthead");
var uiHeader = document.querySelector(".ui-header");
var uiHeaderNavToggle = document.querySelector(".ui-header__nav-toggle");
var uiTray = document.querySelector(".ui-tray");
var uiTrayClose = document.querySelector(".ui-tray__close");
var uiTrayTabs = document.querySelectorAll(".ui-tray__tab");
var uiTrayMain = document.querySelector(".ui-tray__main");
var uiTrayPanels = document.querySelectorAll(".ui-tray__panel");
var uiNav = document.querySelector(".ui-nav");
var uiSubheadMenuToggle = document.querySelector(".ui-subhead__menu-toggle");
var uiMenu = document.querySelector(".ui-menu");
var uiOverlay = document.querySelector(".ui-overlay");
var uiPlaceholder = document.querySelector(".ui-placeholder");
var uiTooltips = document.querySelector(".ui-tooltips");
var uiSearch =document.querySelector(".ui-search");
var uiSearchToggle = document.querySelector(".ui-header__search-toggle");
var uiSearchBack = document.querySelector(".ui-search__back");
var uiSearchClear = document.querySelector(".ui-search__clear");
var uiSearchInput = document.querySelector(".ui-search__input");
var uiSearchForm = document.querySelector(".ui-search__form");
var uiSearchResults = document.querySelector(".ui-search__results");
var uiSearchSubmit = document.querySelector(".ui-search__submit");

// ********************
// Media Queries
var mediaMedium = window.matchMedia("(min-width: 768px)");
var mediaLarge = window.matchMedia("(min-width: 1024px)");
var mediaXlarge = window.matchMedia("(min-width: 1280px)");

// ********************
// Fastclick for mobile browsers
uiRoot.addEventListener("touchstart", function () {}, { passive: true });

// ********************
// Keyboard event helpers

// escClick
function escKey(event) {
  return event.key == "Escape";
}

// Elements in the Tab order. tabindex="-1" opts an element out (e.g. the search
// combobox's options, which are reached with the arrow keys instead).
var FOCUSABLE = [
  'a[href]:not([tabindex="-1"])',
  'button:not([disabled]):not([tabindex="-1"])',
  'input:not([disabled]):not([type="hidden"]):not([tabindex="-1"])',
  'select:not([disabled]):not([tabindex="-1"])',
  'textarea:not([disabled]):not([tabindex="-1"])',
  '[tabindex]:not([tabindex="-1"])',
].join(", ");

// Focus trap: constrain Tab/Shift+Tab within a container, or a list of them
// in document order
function trapFocus(evt, containers) {
  if (evt.key !== "Tab") return;

  var focusable = [].concat(containers).flatMap(function (container) {
    return container.matches(FOCUSABLE) ? [container] : Array.from(container.querySelectorAll(FOCUSABLE));
  }).filter(function (el) {
    return el.offsetParent !== null; // visible only
  });
  if (focusable.length === 0) return;

  var first = focusable[0];
  var last = focusable[focusable.length - 1];

  if (evt.shiftKey && document.activeElement === first) {
    evt.preventDefault();
    last.focus();
  } else if (!evt.shiftKey && document.activeElement === last) {
    evt.preventDefault();
    first.focus();
  }
}

// Track the element that triggered a panel open, for focus restoration
var focusStack = [];

function saveFocus() {
  focusStack.push(document.activeElement);
}

function restoreFocus() {
  var el = focusStack.pop();
  if (el && el.focus && el.offsetParent !== null) {
    el.focus();
  }
}

function discardFocus() {
  focusStack.pop();
}

// Modal overlays: make everything outside `keep` inert, so neither Tab nor a
// screen reader's virtual cursor reaches the page behind. The overlay stays live
// because clicking it closes the panel, and the tooltip container stays live so
// tooltips for controls inside the panel remain hoverable (WCAG 1.4.13). Only one
// overlay is open at a time.
var inertElements = [];

function inertOutside(keep) {
  releaseInert();
  keep = keep.concat(uiOverlay || [], uiTooltips || []);
  keep.forEach(function (el) {
    for (var node = el; node.parentElement && node !== document.body; node = node.parentElement) {
      Array.from(node.parentElement.children).forEach(function (sibling) {
        var holdsKept = keep.some(function (k) { return sibling.contains(k); });
        if (holdsKept || sibling.inert) return;
        sibling.inert = true;
        inertElements.push(sibling);
      });
    }
  });
}

function releaseInert() {
  inertElements.forEach(function (el) {
    el.inert = false;
  });
  inertElements = [];
}

// The tray and search panels are only dialogs while open as overlays (the tray
// is a plain sidebar when stuck, and the search box sits in the header when closed).
// Closing restores the element's own landmark name from data-landmark-label, if any.
function setDialog(el, label) {
  if (label) {
    el.setAttribute("role", "dialog");
    el.setAttribute("aria-modal", "true");
    el.setAttribute("aria-label", label);
  } else {
    el.removeAttribute("role");
    el.removeAttribute("aria-modal");
    if (el.dataset.landmarkLabel) {
      el.setAttribute("aria-label", el.dataset.landmarkLabel);
    } else {
      el.removeAttribute("aria-label");
    }
  }
}

// ********************
// Resizing

var resizeTimer = null;

function doResize() {
  if (resizeTimer != null) {
    window.cancelAnimationFrame(window.ui.resizeTimer);
  }

  resizeTimer = window.requestAnimationFrame(function () {
    if (uiMasthead) {
      // Size the placeholder to the size of the header
      var mastheadHeight = uiMasthead.offsetHeight;
      uiPlaceholder.style.height = mastheadHeight + "px";

      // The masthead is fixed at large widths, so keep focused and scrolled-to
      // elements from landing underneath it (WCAG 2.4.11)
      document.documentElement.style.scrollPaddingTop = mediaLarge.matches ? mastheadHeight + "px" : "";
    }

    // Position the menu under the masthead
    if (uiMenu != null) {
      uiMenu.style.top = mastheadHeight + "px";
    }

    // Tray resizing
    if (uiTray) {
      if (mediaLarge.matches) {
        uiTray.style.maxHeight =
          window.innerHeight - uiHeader.offsetTop + "px";
      } else {
        uiTray.style.maxHeight = null;
      }
    }

    // Search resizing
    if (uiSearch) {
      if (mediaMedium.matches) {
        uiSearch.style.maxHeight =
          window.innerHeight - uiHeader.offsetTop - 16 + "px";
      } else {
        uiSearch.style.maxHeight = null;
      }
    }

    // Hide menus and such on screen size changes
    if (mediaLarge.matches) {
      closeNav(true);
      closeMenu(true);
    }

    // A tray opened as an overlay becomes the stuck sidebar when the viewport
    // widens past the sticky breakpoint, so drop its dialog state. Focus returns
    // to the opening tab since the tray's close button hides when stuck. Either
    // way across the breakpoint, re-sync the tabs' aria-expanded with whether
    // the panel is showing, matching a page loaded at that width.
    if (uiTray) {
      var activeTab = uiTray.querySelector(".ui-tray__tab--active");
      if (isTrayOpen() && isTrayStuck()) closeTray();
      if (activeTab && !isTrayOpen()) activateTray(activeTab.dataset.tray);
    }

    // Remove the unsized flag (used to prevent content jitter)
    uiRoot.classList.remove("ui--unsized");

    // Clear the timer since we're done
    resizeTimer = null;
  });
}

doResize();

window.ui.resize = doResize;
window.addEventListener("resize", doResize, { passive: true });
window.addEventListener("load", doResize, { passive: true });
window.addEventListener("orientationchange", doResize, { passive: true });

// ********************
// Overlay - clicking the overlay always closes everything easy

function doOverlayClick(evt) {
  closeNav();
  closeMenu();
  closeSearch();
  closeTray();
  evt.preventDefault();
}

if (uiOverlay) {
  uiOverlay.addEventListener("click", doOverlayClick);
}

// ********************
// Nav

function isNavOpen() {
  return uiRoot.classList.contains("ui--nav-open");
}

function doNavKeydown(evt) {
  if (escKey(evt)) {
    closeNav();
    evt.preventDefault();
  } else if (uiNav) {
    // The toggle (now "Close navigation") sits outside #ui-nav, so trap both
    trapFocus(evt, [uiHeaderNavToggle, uiNav]);
  }
}

function openNav() {
  if (isNavOpen()) {
    return;
  }

  closeMenu(true);
  closeSearch(true);
  closeTray(true);
  saveFocus();
  uiRoot.classList.add("ui--nav-open");
  uiHeaderNavToggle.setAttribute("aria-expanded", "true");
  uiHeaderNavToggle.setAttribute("aria-label", "Close navigation");
  document.addEventListener("keydown", doNavKeydown);
  if (uiNav) inertOutside([uiHeaderNavToggle, uiNav]);

  if (uiNav) {
    requestAnimationFrame(function () {
      var firstLink = uiNav.querySelector(FOCUSABLE);
      if (firstLink) firstLink.focus();
    });
  }
}

function closeNav(skipRestore) {
  if (!isNavOpen()) {
    return;
  }

  uiRoot.classList.remove("ui--nav-open");
  uiHeaderNavToggle.setAttribute("aria-expanded", "false");
  uiHeaderNavToggle.setAttribute("aria-label", "Open navigation");
  document.removeEventListener("keydown", doNavKeydown);
  releaseInert();
  if (skipRestore) { discardFocus(); } else { restoreFocus(); }
}

function toggleNav() {
  if (isNavOpen()) {
    closeNav();
  } else {
    openNav();
  }
}

function doNavToggleClick(evt) {
  toggleNav();
  evt.preventDefault();
}


window.ui.openNav = openNav;
window.ui.closeNav = closeNav;
window.ui.toggleNav = toggleNav;

if (uiHeaderNavToggle) {
  uiHeaderNavToggle.addEventListener("click", doNavToggleClick);
}

// ********************
// Menu

function isMenuOpen() {
  return uiRoot.classList.contains("ui--menu-open");
}

function doMenuKeydown(evt) {
  if (escKey(evt)) {
    closeMenu();
    evt.preventDefault();
  } else if (uiMenu) {
    trapFocus(evt, [uiSubheadMenuToggle, uiMenu].filter(Boolean));
  }
}

function openMenu() {
  if (isMenuOpen()) {
    return;
  }

  closeNav(true);
  closeSearch(true);
  closeTray(true);
  saveFocus();
  uiRoot.classList.add("ui--menu-open");
  if (uiSubheadMenuToggle) uiSubheadMenuToggle.setAttribute("aria-expanded", "true");
  document.addEventListener("keydown", doMenuKeydown);
  if (uiMenu) inertOutside([uiSubheadMenuToggle, uiMenu].filter(Boolean));

  if (uiMenu) {
    requestAnimationFrame(function () {
      var firstItem = uiMenu.querySelector(FOCUSABLE);
      if (firstItem) firstItem.focus();
    });
  }
}

function closeMenu(skipRestore) {
  if (!isMenuOpen()) {
    return;
  }

  uiRoot.classList.remove("ui--menu-open");
  if (uiSubheadMenuToggle) uiSubheadMenuToggle.setAttribute("aria-expanded", "false");
  document.removeEventListener("keydown", doMenuKeydown);
  releaseInert();
  if (skipRestore) { discardFocus(); } else { restoreFocus(); }
}

function toggleMenu() {
  if (isMenuOpen()) {
    closeMenu();
  } else {
    openMenu();
  }
}

function doMenuToggleClick(evt) {
  toggleMenu();
  evt.preventDefault();
}


window.ui.openMenu = openMenu;
window.ui.closeMenu = closeMenu;
window.ui.toggleMenu = toggleMenu;

if (uiSubheadMenuToggle) {
  uiSubheadMenuToggle.addEventListener("click", doMenuToggleClick);
}

// ********************
// Tray

function isTrayOpen() {
  return uiRoot.classList.contains("ui--tray-open");
}

function isTrayStuck() {
  return uiRoot.classList.contains("ui--tray-sticky") && mediaXlarge.matches;
}

var activeTrayPanel = null;

function doTrayKeydown(evt) {
  if (escKey(evt)) {
    closeTray();
    evt.preventDefault();
  } else if (uiTray) {
    trapFocus(evt, uiTray);
  }
}

function openTray(name) {
  if (name === null) {
    return closeTray();
  }

  closeNav(true);
  closeMenu(true);
  closeSearch(true);

  activateTray(name);

  if (!isTrayStuck()) {
    // Switching tabs in an open tray only swaps the panel; saving focus again
    // would leave a stale entry on the focus stack
    if (!isTrayOpen()) {
      saveFocus();
      uiRoot.classList.add("ui--tray-open");
      document.addEventListener("keydown", doTrayKeydown);
      inertOutside([uiTray]);

      // Move focus into tray
      requestAnimationFrame(function () {
        if (uiTrayClose) uiTrayClose.focus();
      });
    }
    setDialog(uiTray, activeTrayLabel());

    if (!mediaLarge.matches) {
      bodyScrollLock.disableBodyScroll(activeTrayPanel);
    }
  }

  // Set aria-expanded after tray is open
  uiTrayTabs.forEach(function (tab) {
    tab.setAttribute("aria-expanded", tab.dataset.tray === name ? "true" : "false");
  });
}

function activeTrayLabel() {
  var tab = uiTray.querySelector(".ui-tray__tab--active");
  return tab ? tab.getAttribute("aria-label") : "Tray";
}

function activateTray(name) {
  var trayVisible = isTrayOpen() || isTrayStuck();
  uiTrayTabs.forEach(function (tab) {
    if (tab.dataset.tray === name) {
      tab.classList.add("ui-tray__tab--active");
      tab.setAttribute("aria-expanded", trayVisible ? "true" : "false");
    } else {
      tab.classList.remove("ui-tray__tab--active");
      tab.setAttribute("aria-expanded", "false");
    }
  });

  uiTrayPanels.forEach(function (panel) {
    if (panel.dataset.tray === name) {
      panel.classList.add("ui-tray__panel--active");
      activeTrayPanel = panel;
    } else {
      panel.classList.remove("ui-tray__panel--active");
    }
  });
}

function loadTrayPanel(panel) {
  var url = panel.dataset.url;
  if (!url) {
    return;
  }

  panel.classList.add("ui-tray__panel--loading");

  var xhr = new XMLHttpRequest();
  xhr.open("GET", url);
  xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
  xhr.onload = function () {
    if (xhr.status === 200) {
      // Create replacement DIV
      var newPanel = document.createElement("div");
      newPanel.innerHTML = xhr.responseText;
      newPanel = newPanel.children[0];
      newPanel.removeAttribute("data-url");

      // Keeps active if currently active
      if (panel.classList.contains("ui-tray__panel--active")) {
        newPanel.classList.add("ui-tray__panel--active");
      }

      // Hide any loading or error states
      newPanel.classList.remove("ui-tray__panel--loading");
      newPanel.classList.remove("ui-tray__panel--error");

      // put into the dom
      uiTrayMain.replaceChild(newPanel, panel);
      panel = null;

      // refresh the panels
      uiTrayPanels = document.querySelectorAll(".ui-tray__panel");

      // TODO? Tooltips
      window.ui.initTooltips();
      addNewTabHints(newPanel);
    } else {
      showTrayPanelError(panel);
    }

    updateTrayCounts();
  };
  xhr.onerror = function () {
    showTrayPanelError(panel);
  };

  xhr.send();
}

// The alert region is in the DOM from page load, so filling it is announced;
// un-hiding a role="alert" element isn't reliably
function showTrayPanelError(panel) {
  panel.classList.remove("ui-tray__panel--loading");
  panel.classList.add("ui-tray__panel--error");

  var alert = panel.querySelector(".ui-tray__alert");
  var message = panel.querySelector(".ui-tray__error .ui-tray__info-message");
  if (alert && message) {
    alert.textContent = Array.from(message.children, function (el) { return el.textContent.trim(); }).join(". ");
  }
}

function updateTrayCounts() {
  var unreads = {};
  var alert = false;

  uiTrayPanels.forEach(function (panel) {
    if (panel.hasAttribute("data-unread")) {
      unreads[panel.dataset.tray] = true;
    }
    if (panel.hasAttribute("data-alert")) {
      alert = true;
    }
  });

  uiTrayTabs.forEach(function (tab) {
    if (unreads[tab.dataset.tray] === true) {
      tab.setAttribute("data-unread", "");
    } else {
      tab.removeAttribute("data-unread");
    }

    if (tab.dataset.tray === "notifications" && alert === true) {
      tab.setAttribute("data-alert", "");
    } else {
      tab.removeAttribute("data-alert");
    }
  });
}

function closeTray(skipRestore) {
  if (!isTrayOpen()) {
    return;
  }

  uiRoot.classList.remove("ui--tray-open");
  uiTrayTabs.forEach(function (tab) {
    tab.setAttribute("aria-expanded", "false");
  });
  document.removeEventListener("keydown", doTrayKeydown);
  setDialog(uiTray, null);
  releaseInert();
  bodyScrollLock.clearAllBodyScrollLocks();
  if (skipRestore) { discardFocus(); } else { restoreFocus(); }
}

function doTrayTabClick(evt) {
  openTray(evt.currentTarget.dataset.tray);
  evt.preventDefault();
}

function doTrayCloseClick(evt) {
  closeTray();
  evt.preventDefault();
}


window.ui.openTray = openTray;
window.ui.closeTray = closeTray;

// Make sure notifications is activated
if (uiTray) {
  uiTrayTabs.forEach(function (tab) {
    tab.addEventListener("click", doTrayTabClick);
  });

  uiTrayPanels.forEach(function (panel) {
    loadTrayPanel(panel);
  });

  uiTrayClose.addEventListener("click", doTrayCloseClick);

  // Activate the first available tray, or notifications
  if (uiTrayTabs[0]) {
    activateTray(uiTrayTabs[0].dataset.tray);
  } else {
    activateTray("notifications");
  }
}

// ********************
// Search

var searchSavedQuery = "";
var searchCache = {};
var pendingQuery = null;

function doSearchKeydown(evt) {
  if (escKey(evt)) {
    closeSearch();
    evt.preventDefault();
  } else if (uiSearch) {
    trapFocus(evt, uiSearch);
  }
}

// The input is an APG combobox (see combobox.js) over #ui-search-listbox
var searchCombobox = uiSearch ? createCombobox(uiSearchInput, uiSearchResults, "ui-search-option-") : null;

// Called after every render into the results: the options are new elements, so
// give them ids and drop the stale highlight, then announce the count.
function renderSearchResults(html) {
  uiSearchResults.innerHTML = html;
  searchCombobox.reset();
  announceSearchResults();
}

function openSearch(query, scope) {
  closeNav(true);
  closeMenu(true);
  closeTray(true);
  saveFocus();

  uiRoot.classList.add("ui--search-open");
  if (uiSearchToggle) uiSearchToggle.setAttribute("aria-expanded", "true");
  uiSearchInput.setAttribute("aria-expanded", "true");
  // Typing into the closed header input opens search; keep what was typed.
  if (isSearchQueryBlank()) uiSearchInput.value = searchSavedQuery;
  preloadAnswerData();

  bodyScrollLock.disableBodyScroll(uiSearchResults);
  document.addEventListener("keydown", doSearchKeydown);
  setDialog(uiSearch, "Search");
  inertOutside([uiSearch]);
  window.ui.initTooltips();

  requestAnimationFrame(function () {
    if (uiSearchInput) uiSearchInput.focus();
  });
}

function preloadAnswerData() {
  if (!uiSearch.classList.contains("ui-search--answers-enabled") || uiSearch.classList.contains("ui-search--answers-preloaded")) {
    return;
  }
  uiSearch.classList.add("ui-search--answers-preloaded");
  var preloadUrl = uiSearch.dataset.preloadUrl;
  var xhrRequest = new XMLHttpRequest();
  xhrRequest.open("POST", preloadUrl);
  xhrRequest.setRequestHeader("X-Requested-With", "XMLHttpRequest");
  var csrfToken = document.querySelector("meta[name=csrf-token]");
  if (csrfToken) {
    xhrRequest.setRequestHeader("X-CSRF-Token", csrfToken.getAttribute("content"));
  }
  xhrRequest.send();
}

function closeSearch(skipRestore) {
  // Like the other panels: the open* functions call this unconditionally, and
  // running it while closed would pop someone else's saved focus
  if (!isSearchOpen()) {
    return;
  }

  cancelSuggestions();
  uiRoot.classList.remove("ui--search-open");
  if (uiSearchToggle) uiSearchToggle.setAttribute("aria-expanded", "false");
  uiSearchInput.setAttribute("aria-expanded", "false");
  searchCombobox.setActive(null);
  searchSavedQuery = searchQuery();
  uiSearchInput.value = "";
  setDialog(uiSearch, null);
  releaseInert();
  bodyScrollLock.clearAllBodyScrollLocks();
  document.removeEventListener("keydown", doSearchKeydown);
  if (skipRestore) { discardFocus(); } else { restoreFocus(); }
}

function isSearchOpen() {
  return uiRoot.classList.contains("ui--search-open");
}

function isSearchQueryBlank() {
  return searchQuery() === "";
}

function searchQuery() {
  return uiSearchInput.value.replace(/\s+/g, " ").trim();
}

function searchQueryCacheKey() {
  return searchQuery();
}

function searchResultsUrl(query) {
  var url = uiSearchForm.dataset.url;

  var params = new URLSearchParams();
  params.set("query", query);
  url = url + "?" + params.toString();

  return url;
}

function searchSuggestUrl(query) {
  var params = new URLSearchParams();
  params.set("query", query);
  return uiSearchForm.dataset.suggestUrl + "?" + params.toString();
}

var searchXHR = null;

// Autocomplete suggestions (index-only, fired as the user types). Separate from
// the default-menu request so neither clobbers the other.
var suggestXHR = null;
var suggestDebounce = null;
var suggestCache = {};
var SUGGEST_DEBOUNCE_MS = 180;

function cancelSuggestions() {
  clearTimeout(suggestDebounce);
  suggestDebounce = null;
  if (suggestXHR != null) {
    suggestXHR.abort();
    suggestXHR = null;
  }
}

function showSuggestions(html, forQuery) {
  // Ignore a stale render if the query moved on.
  if (searchQuery() !== forQuery) return;
  renderSearchResults(html);
  window.ui.initTooltips();
}

function loadSearchSuggestions() {
  var activeQuery = searchQuery();
  if (activeQuery === "") return;

  // Cache hit: render with no round-trip (covers retyping and backspacing).
  var cached = suggestCache[activeQuery];
  if (cached != null) {
    showSuggestions(cached, activeQuery);
    return;
  }

  if (suggestXHR != null) suggestXHR.abort();

  var xhr = new XMLHttpRequest();
  suggestXHR = xhr;
  xhr.open("GET", searchSuggestUrl(activeQuery));
  xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
  xhr.onload = function () {
    if (xhr.status === 200) {
      suggestCache[activeQuery] = xhr.responseText;
      showSuggestions(xhr.responseText, activeQuery);
    }
    // Only clear the global if a newer request hasn't replaced us.
    if (suggestXHR === xhr) suggestXHR = null;
  };
  xhr.send();
}

function announceSearchResults() {
  var statusEl = document.querySelector(".ui-search__status");
  var listbox = document.getElementById("ui-search-listbox");
  // The default menu also renders on page load; only announce while search is open.
  if (!statusEl || !listbox || !isSearchOpen()) return;

  // Each partial renders its own status text, matching what it shows when empty
  statusEl.textContent = listbox.dataset.status || "";
}

function loadSearchResults() {
  var activeQuery = searchQuery();
  var activeQueryCacheKey = searchQueryCacheKey();

  if (searchCache[activeQueryCacheKey] != null) {
    // console.log('[HIT]  Showing results for:', activeQuery)
    renderSearchResults(searchCache[activeQueryCacheKey]);
    uiSearch.classList.remove("ui-search--loading");
  } else {
    if (pendingQuery == activeQuery) {
      return;
    }

    if (searchXHR != null) {
      searchXHR.abort();
    }

    uiSearch.classList.add("ui-search--loading");
    var resultsURL = searchResultsUrl(activeQuery);
    // console.log('[MISS] Fetching results for:', activeQuery, resultsURL)

    pendingQuery = activeQuery;

    searchXHR = new XMLHttpRequest();
    searchXHR.open("GET", resultsURL);
    searchXHR.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    searchXHR.onload = function () {
      if (searchXHR.status === 200) {
        searchCache[activeQueryCacheKey] = searchXHR.responseText;
        // remove from pending
        pendingQuery = null;

        // If the user typed while this loaded, the suggestions own the panel now;
        // re-running loadSearchResults would fetch full results for the new query.
        if (searchQueryCacheKey() === activeQueryCacheKey) {
          loadSearchResults();
        } else {
          uiSearch.classList.remove("ui-search--loading");
        }
      }
    };

    searchXHR.send();
  }
  window.ui.initTooltips();
}

function clearSearchQuery() {
  uiSearchInput.value = "";
  searchSavedQuery = "";
  uiSearchInput.focus();
  loadSearchResults();
  uiSearch.classList.remove("ui-search--query");
}

function doSearchBackClick(evt) {
  closeSearch();
  evt.preventDefault();
}

function doSearchClearClick(evt) {
  clearSearchQuery();
  evt.preventDefault();
}

function doSearchInputClick(evt) {
  // When search is already open, clicking the input must not re-run openSearch:
  // it would overwrite the in-progress value with the stale searchSavedQuery.
  // Let the click fall through so the browser places the caret normally.
  if (isSearchOpen()) return;

  openSearch(null, null);
  evt.preventDefault();
}

function doSearchInputKeypress(evt) {
  if (evt.key === "ArrowDown" || evt.key === "ArrowUp") {
    evt.preventDefault();
    if (isSearchOpen()) {
      searchCombobox.move(evt.key === "ArrowDown" ? 1 : -1);
    } else {
      openSearch(null, null);
    }
    return;
  }

  if (evt.key == "Enter") {
    evt.preventDefault();
    // click() rather than following href, so the option's tracking beacons fire
    var option = searchCombobox.active();
    if (option) {
      option.click();
    } else if (!isSearchQueryBlank()) {
      window.location.href = uiSearchForm.action + "?" + new URLSearchParams({ query: searchQuery() });
    }
    return;
  }

  if (!isSearchOpen() && evt.key === " " && isSearchQueryBlank()) {
    openSearch(null, null);
    evt.preventDefault();
  }
}

function doSearchSubmitClick(evt) {
  evt.preventDefault();
  if (!isSearchQueryBlank()) {
    window.location.href = uiSearchForm.action + "?" + new URLSearchParams({ query: searchQuery() });
  }
}

function doSearchInputInput(evt) {
  if (!isSearchOpen()) openSearch(null, null);

  if (isSearchQueryBlank()) {
    uiSearch.classList.remove("ui-search--query");
    cancelSuggestions();
    loadSearchResults(); // restore the default (empty-query) menu
    return;
  }

  uiSearch.classList.add("ui-search--query");

  // Cache hit renders immediately (no debounce, no round-trip); otherwise
  // debounce the network request as the user keeps typing.
  if (suggestCache[searchQuery()] != null) {
    cancelSuggestions();
    loadSearchSuggestions();
    return;
  }

  clearTimeout(suggestDebounce);
  suggestDebounce = setTimeout(loadSearchSuggestions, SUGGEST_DEBOUNCE_MS);
}


function trackStandaloneMode() {
  if (window.navigator.standalone) {
    var xhrRequest = new XMLHttpRequest();
    xhrRequest.open("POST", "/_ui/standalone");
    xhrRequest.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    var csrfToken = document.querySelector("meta[name=csrf-token]");
    if (csrfToken) {
      xhrRequest.setRequestHeader("X-CSRF-Token", csrfToken.getAttribute("content"));
    }
    xhrRequest.send();
  }
}

trackStandaloneMode();

if (uiSearch) {
  loadSearchResults();

  uiSearchBack.addEventListener("click", doSearchBackClick);

  uiSearchInput.addEventListener("click", doSearchInputClick);
  uiSearchInput.addEventListener("keydown", doSearchInputKeypress);

  uiSearchToggle.addEventListener("click", doSearchInputClick);

  uiSearchClear.addEventListener("click", doSearchClearClick);

  uiSearchSubmit.addEventListener("click", doSearchSubmitClick);

  uiSearchInput.addEventListener("input", doSearchInputInput);
}

// ********************
// External links: add screen reader hint for target="_blank" links (SSO services where back-button breaks)
function addNewTabHints(container) {
  (container || document).querySelectorAll('a[target="_blank"]:not([data-new-tab-hint])').forEach(function (link) {
    var hint = document.createElement("span");
    hint.textContent = " (opens in new tab)";
    hint.className = "sr-only";
    link.appendChild(hint);
    link.setAttribute("data-new-tab-hint", "");
  });
}

addNewTabHints();
window.ui.addNewTabHints = addNewTabHints;

window.ui.openSearch = openSearch;
